import { useCallback } from 'react';

import { useSelector } from 'third-party';

import { appSelectors } from 'selectors';

import { type APIUserRight, APIUserType } from 'types/api';

export const useUserRightsIn = () => {
  const userRights = useSelector(appSelectors.organizationUserRights);
  const userType = useSelector(appSelectors.organizationUserType);

  return useCallback(
    (userRight: APIUserRight | APIUserRight[]) =>
      userType === APIUserType.Admin ||
      (!!userRights &&
        (Array.isArray(userRight) ? userRight : [userRight]).some(right =>
          userRights.includes(right),
        )),

    [userRights, userType],
  );
};
